var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.01074V19.0107H8V9.01074H16ZM14.5 3.01074H9.5L8.5 4.01074H5V6.01074H19V4.01074H15.5L14.5 3.01074ZM18 7.01074H6V19.0107C6 20.1107 6.9 21.0107 8 21.0107H16C17.1 21.0107 18 20.1107 18 19.0107V7.01074Z",
    fill: "#A1A1A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigTrashIcon);
export default __webpack_public_path__ + "static/media/big-trash-icon.792e4b93.svg";
export { ForwardRef as ReactComponent };